import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import getCopilotsBySite from "~/operatorApplication/ts/service/copilot/getCopilotsBySite";

export async function toggleCopilotSuggests(client: OperatorApplicationApi.OperatorApplicationClientOpenApiModel, value: boolean, auth?: OperatorApplicationApi.OperatorGetParamsIntegrationAuthOpenApiModel) {
    client.copilot.enabled = value;
    let p: OperatorApplicationApi.OperatorCopilotToggleOpenApiModel = {
        username: client.username,
        enabled: value,
    };
    if (auth) {
        p.integration = {
            platformId: auth.platformId,
            authPrimaryId: auth.authPrimaryId
        }
    }
    return await (new OperatorApiRequest({
        url: "/copilot/toggleCopilot",
        p,
        silent: true
    })).send()
}

export function getCopilotAuthByClient(client: OperatorApplicationApi.OperatorApplicationClientOpenApiModel, site: OperatorApplicationApi.OperatorGetParamsSiteOpenApiModel) {
    let authList = getCopilotsBySite(site);
    return authList.find(item => {
        return item.authPrimaryId === client.copilot.authPrimaryId && item.platformId === client.copilot.platformId;
    });
}